import { __assign, __read } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { RgbColorPicker } from "react-colorful";
import TextFieldV2 from "../TextFieldV2";
var StyledComponent = function (props) {
    var color = props.color, onChange = props.onChange, showRGB = props.showRGB, direction = props.direction;
    var _a = __read(React.useState({
        r: 255,
        g: 255,
        b: 255,
    }), 2), rgbColor = _a[0], setrgbColor = _a[1];
    var _b = __read(React.useState(JSON.stringify(color || rgbColor)), 2), currentColor = _b[0], setCurrentColor = _b[1];
    return (_jsxs("div", { id: props === null || props === void 0 ? void 0 : props.id, style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: direction,
            width: direction === "column" ? "200px" : "auto",
            height: direction === "row" ? "200px" : "auto",
        }, "data-temporary": currentColor, children: [_jsx("div", { style: {
                    marginRight: direction === "row" ? "20px" : 0,
                    marginBottom: direction === "column" ? "10px" : 0,
                }, children: _jsx(RgbColorPicker, { color: rgbColor || color, onChange: function (newColor) {
                        setrgbColor(newColor);
                        onChange === null || onChange === void 0 ? void 0 : onChange(newColor);
                        setCurrentColor(JSON.stringify(newColor));
                    } }) }), showRGB && (_jsxs("div", { style: {
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                }, children: [_jsx("div", { style: { marginBottom: direction === "column" ? "5px" : "25px" }, children: _jsx(TextFieldV2, { title: "Red", width: direction === "row" ? "150px" : "100%", type: "number", value: rgbColor.r.toString() || (color === null || color === void 0 ? void 0 : color.r.toString()), onChange: function (e) {
                                color && (onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, color), { r: parseInt(e.target.value) })));
                                setrgbColor(__assign(__assign({}, rgbColor), { r: parseInt(e.target.value) }));
                            }, numberOptions: {
                                max: 255,
                                min: 0,
                                onlyInteger: true,
                            } }) }), _jsx("div", { style: { marginBottom: direction === "column" ? "5px" : "25px" }, children: _jsx(TextFieldV2, { title: "Green", width: direction === "row" ? "150px" : "100%", type: "number", value: rgbColor.g.toString() || (color === null || color === void 0 ? void 0 : color.g.toString()), onChange: function (e) {
                                color && (onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, color), { g: parseInt(e.target.value) })));
                                setrgbColor(__assign(__assign({}, rgbColor), { g: parseInt(e.target.value) }));
                            }, numberOptions: {
                                max: 255,
                                min: 0,
                            } }) }), _jsx("div", { style: { marginBottom: "5px" }, children: _jsx(TextFieldV2, { title: "Blue", width: direction === "row" ? "150px" : "100%", type: "number", value: rgbColor.b.toString() || (color === null || color === void 0 ? void 0 : color.b.toString()), onChange: function (e) {
                                color && (onChange === null || onChange === void 0 ? void 0 : onChange(__assign(__assign({}, color), { b: parseInt(e.target.value) })));
                                setrgbColor(__assign(__assign({}, rgbColor), { b: parseInt(e.target.value) }));
                            }, numberOptions: {
                                max: 255,
                                min: 0,
                            } }) })] }))] }));
};
export default StyledComponent;
